// Classes
import { ProspectProfileReducerState } from "Containers/Filter/ProspectProfile/classes/prospectProfile.classes";
import { AttributeObject } from "../classes/attributes.classes";

/**
 * @function getEntryTermAttributes
 *
 * Post-processes the attributes for this section of the filter
 *
 * @param {ProspectProfileReducerState} prospectProfile - The current state
 * of the Prospect Profile filter section.
 * @return {AttributeObject | undefined}
 *
 * @example
 *
 *     getEntryTermAttributes(prospectProfile)
 */
export const getEntryTermAttributes = (
  prospectProfile: ProspectProfileReducerState
) => {
  let attributeArray: any[] = [];

  switch (prospectProfile.entryTerm.selection) {
    case "Term-Year":
      const values = prospectProfile.entryTerm.value;
      for (const value of values) {
        const termYear = value.value.split(" ");
        const term = termYear[0];
        const year = termYear[1];
        attributeArray.push(`${term} ${year}`);
      }
      break;
    case "Term":
      attributeArray = [
        (prospectProfile.entryTerm.value.fall && "Fall") || undefined,
        (prospectProfile.entryTerm.value.spring && "Spring") || undefined
      ].filter(attributeObject => typeof attributeObject !== "undefined");
      break;
    case "Year":
      attributeArray = [
        `${prospectProfile.entryTerm.value.lower} - ${prospectProfile.entryTerm.value.upper}`
      ];
      break;
  }

  let attributeObject: any;

  if (attributeArray.length > 0) {
    attributeObject = new AttributeObject(
      (attributeArray.length > 1 && `Entry Term=${attributeArray.length}`) ||
        attributeArray[0],
      "standard",
      attributeArray.length > 1 && attributeArray
    );
  } else {
    attributeObject = undefined;
  }

  return attributeObject;
};
try {
    // @ts-ignore
    getEntryTermAttributes.displayName = "getEntryTermAttributes";
    // @ts-ignore
    getEntryTermAttributes.__docgenInfo = { "description": "", "displayName": "getEntryTermAttributes", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Attributes/utilities/getEntryTermAttributes.ts#getEntryTermAttributes"] = { docgenInfo: getEntryTermAttributes.__docgenInfo, name: "getEntryTermAttributes", path: "src/shared/containers/Attributes/utilities/getEntryTermAttributes.ts#getEntryTermAttributes" };
}
catch (__react_docgen_typescript_loader_error) { }